import { render, staticRenderFns } from "./NavigationBar.vue?vue&type=template&id=2412b648&"
import script from "./NavigationBar.vue?vue&type=script&lang=js&"
export * from "./NavigationBar.vue?vue&type=script&lang=js&"
import style0 from "./NavigationBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NavigationBar.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/NavigationBar.vue
// module id = 1638
// module chunks = 1